import React, { FC } from 'react';
import { Breadcrumbs, BreadcrumbsItem } from 'fronton-react';
import { useSelector } from 'react-redux';
import { getBreadcrumbs } from 'features/page-model/ducks/get-model';
import { analyticsUtils, patchUrlByLocale } from 'utils';
import { getBreadcrumbsPath } from './get-breadcrumbs-path';
import { sectionStyle } from './style';

export const BreadcrumbsSection: FC = () => {
  let breadcrumbs = [...(useSelector(getBreadcrumbs) || [])];

  if (breadcrumbs.length > 1) {
    breadcrumbs.pop();
  }
  function sendGA(index: number) {
    const elementBlock = getBreadcrumbsPath(breadcrumbs);
    const elementText = getBreadcrumbsPath(breadcrumbs.slice(0, index + 1));

    analyticsUtils.sendEvent('GA:clickButton', {
      elementType: 'button',
      elementName: 'breadcrumbs',
      elementText,
      elementBlock,
    });
  }

  if (breadcrumbs) {
    return (
      <section className={sectionStyle}>
        <Breadcrumbs>
          {breadcrumbs.map(({ label, link }, index) => (
            <BreadcrumbsItem
              key={label}
              onClick={() => sendGA(index)}
              href={patchUrlByLocale(link)}
              data-qa="breadcrumb"
            >
              {label}
            </BreadcrumbsItem>
          ))}
        </Breadcrumbs>
      </section>
    );
  }

  return null;
};
